import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { FormsService } from 'src/app/services/Forms/forms.service';

@Component({
  selector: 'ipm-login-signup',
  templateUrl: './login-signup.component.html',
  styleUrls: ['./login-signup.component.scss']
})
export class LoginSignupComponent implements OnInit {
  @Input() authType: string;
  authForm : FormGroup = new FormGroup({});
  isEmailShow: boolean = false;
  isConfirmPasswordShow: boolean = false;
  isShowPassword: boolean = false; 
  isNameShow: boolean = false; 
  isShowCurrentPassword: boolean = false; 
  isAcceptCondition: boolean = false;
  constructor(public formService: FormsService,
  public commonService: CommonService
  ) {
  }

  ngOnInit(): void {
    this.formService.textConfirmTypeField = false;
    this.formService.textTypeField = false;
    this.authForm = new FormGroup({
      'email':this.formService.getFormControl('email'),
    });
     if(this.authType ===  'login') {
      this.authForm.addControl('password', this.formService.getFormControl('password-login'));
        this.isEmailShow = true;
        this.isShowPassword = true;
        // this.authForm.controls.password.removeValidators(Validators.minLength(8));
     } else  if (this.authType === 'signup') {
        this.authForm.addControl('password', this.formService.getFormControl('password'));
        this.authForm.addControl('confirmPassword', this.formService.getFormControl('confirm-password'));
        this.authForm.addControl('isAcceptTermCondition', this.formService.getFormControl(''));
        this.isEmailShow = true;
        this.isShowPassword = true;
        this.isConfirmPasswordShow = true;
        this.isAcceptCondition = true;
     } else if (this.authType ===  'change-password') {
      this.authForm.removeControl('email');
      this.authForm.addControl('password', this.formService.getFormControl('password'));
      this.authForm.addControl('confirmPassword', this.formService.getFormControl('confirm-password'));
      this.authForm.addControl('currentPassword', this.formService.getFormControl('password'));
      this.isEmailShow = false;
      this.isShowPassword = true;
      this.isConfirmPasswordShow = true;
      this.isShowCurrentPassword =  true;
     } else if (this.authType === 'reset-password' || this.authType === 'guest-change-password') {
      this.authForm.removeControl('email');
      this.authForm.addControl('password', this.formService.getFormControl('password'));
      this.authForm.addControl('confirmPassword', this.formService.getFormControl('confirm-password'));
      this.isEmailShow = false;
      this.isShowPassword = true;
      this.isConfirmPasswordShow = true;
      this.isShowCurrentPassword =  false;
     } else  {
       this.authForm.removeControl('password');
       this.isEmailShow = true;
    }
  }

}
